module.exports = __webpack_public_path__ + "img/ressoarte05.87bc3835.jpg";